export const Profile_Settings_EN = {
  settings: {
    headline: "Settings",
    desc: "Manage your account settings and set your users avatar.",
    tabs: {
      yourInfo: "Your information",
      profileImage: "Profile image",
      connections: "Connections",
      themes: "Themes",
      preferences: "Preferences",
      changePassword: "Change password",
      otherSettings: "Other settings",
      language: "Language",
    },
    password_reset: {
      head: "Update/reset your account's password",
      steps: {
        1: "Enter email to recieve a 6 digit reset code",
        2: "Enter received 6 digit reset code",
        3: "Enter new password",
        4: "Repeat new password",
      },
    },
    terms:
      "I agree to be contacted by email if I win a giveaway, competition or similar event.",
    sendResetPasswordCode: "Send reset password code",
  },
};
